// 韩语
export const Korean = {
  
	"language_code": "ko",
	"get_btn": "즉시 받기",
	"unregistered_tip": "미등록 사용자는 계정을 바로 생성합니다.",
	"phone_number": "휴대전화 번호",
	"ver_code": "인증번호",
	"get_ver_code": "인증번호 받기",
	"retrieve_ver_code": "재전송 ({SECONDS})",
	"age_tip": "저는 성인으로 완전한 민사 능력을 갖추고 있으며 ",
	"and": " 및 ",
	"age_tip_1": " 에 동의합니다.",
	"PRIVICY_POLICY": "《개인정보 보호정책》",
	"MEMBER_AGGREMENT": "《회원 약관》",
	"agree_push": "등록한 휴대폰 번호 또는 이메일로 하이디라오 알림 수신에 동의합니다.",
	"CN": "중국",
	"US": "미국",
	"CA": "캐나다",
	"GB": "영국",
	"MY": "말레이시아",
	"AU": "호주",
	"ID": "인도네시아",
	"SG": "싱가포르",
	"TH": "태국",
	"JP": "일본",
	"KR": "한국",
	"VN": "베트남",
	"HK": "홍콩",
	"MO": "마카오",
	"HKM": "캄보디아",
	"TW": "대만",
	"PH": "필리핀",
	"UAE": "아랍에미리트",
	"suc_send": "전송 완료",
	"suc_get": "수령 완료",
	"fail_ver_code": "인증번호 오류",
	"time_end": "행사가 종료되었습니다",
	"not_get_repeat": "중복 수령 불가!",
	"not_get_eligible": "이벤트 조건에 맞지 않아 수령할 수 없습니다.",
	"not_get_late": "한 발 늦었습니다. 행사가 종료되었습니다.",
	"get_coupon": "쿠폰 받기",
	"phone_err": "잘못된 전화번호입니다. 정확한 번호를 입력해주세요.",
	"page_title": "하이디라오 전용 쿠폰 받기",
	"send_code_error": "인증 코드 전송 오류",
	"network_error": "현재 네트워크가 불안정합니다. 나중에 다시 시도해 주세요.",
	"member_status_abnormal": "회원 계정에 이상이 있어 수령할 수 없습니다",
	"send_frequently": "인증 코드가 너무 많이 전송되었습니다. 마지막으로 받은 코드를 입력하거나 나중에 다시 시도하세요.",
	"activity_boom": "신청 인원이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
	"email": "이메일",
	"email_error_tip": "이메일 주소가 잘못되었습니다. 정확한 주소를 입력해주세요.",
	"suc_get_dialog_text": "지금하이디라오회원 앱을 열어 받은 쿠폰을 확인하세요!",
	"btn_sure": "확인",
	"btn_cancel": "취소",
	"suc_dialog_text": "하이디라오 앱을 열거나 LINE에서 회원을 연동하여 받은 쿠폰을 확인하세요!",
	"btn_return": "뒤로가기",
	"btn_download": "다운로드"
}